import { render } from "./Edit.vue?vue&type=template&id=f0924296&scoped=true&bindings={\"nextCategoryId\":\"options\",\"debouncedCategoryUpdate\":\"options\",\"newCategory\":\"options\",\"categoryChanged\":\"options\",\"deleteCategory\":\"options\",\"editTitle\":\"options\",\"editCode\":\"options\",\"addQuestion\":\"options\",\"fetchSurvey\":\"options\",\"loaded\":\"data\",\"showLoading\":\"data\",\"surveydata\":\"data\",\"editingTitle\":\"data\",\"editingCode\":\"data\",\"categoryData\":\"data\",\"loadCategory\":\"data\"}"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=f0924296&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0924296"

export default script